import {
  CbesApi,
  ChatApi,
  DashboardApi,
  DlqApi,
  DlqRedriveApi,
  DownloadS3FileApi,
  PaymentRedriveApi,
  ProjectsApi,
  RedriveApi,
  ShadowTestApi,
  TransactionsApi,
  PublishMockAcadiaInvoiceApi,
} from "./generated-src";

import { getAppSetting } from "../config/AppSettings";
import { Configuration } from "./generated-src/configuration";

export function DetailsApiFactory() {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new CbesApi(new Configuration({ basePath: apiBasePath }));
}

export function DlqInfoApiFactory(): DlqApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DlqApi(new Configuration({ basePath: apiBasePath }));
}

export function DlqRedriveInfoApiFactory(): DlqRedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DlqRedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function DashboardApiFactory(): DashboardApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DashboardApi(new Configuration({ basePath: apiBasePath }));
}

export function RecentTransactionsApiFactory(): TransactionsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new TransactionsApi(new Configuration({ basePath: apiBasePath }));
}

export function ShadowTestApiFactory(): ShadowTestApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ShadowTestApi(new Configuration({ basePath: apiBasePath }));
}

export function ProjectsApiFactory(): ProjectsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ProjectsApi(new Configuration({ basePath: apiBasePath }));
}

export function RedriveApiFactory(): RedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new RedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function PublishMockInvoiceApiFactory(): PublishMockAcadiaInvoiceApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PublishMockAcadiaInvoiceApi(
    new Configuration({ basePath: apiBasePath })
  );
}

export function DownloadS3FileApiFactory(): DownloadS3FileApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DownloadS3FileApi(new Configuration({ basePath: apiBasePath }));
}

export function PaymentRedriveApiFactory(): PaymentRedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PaymentRedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function ChatApiFactory(): ChatApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ChatApi(new Configuration({ basePath: apiBasePath }));
}
